import ComplainSuccess from './ComplainSuccess';

export default ComplainSuccess;
